/**********************************************************
Chemical Application Display: Displays data for viewing & prior to submission

**********************************************************/
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import MowTable from './mowing_table';

const propTypes = {
  application: PropTypes.object,
  editingApplication: PropTypes.bool,
  employees: PropTypes.array,
  previousApplications: PropTypes.array,
  toDelete: PropTypes.bool
};

const MowingApplicationDisplay = ({ application, employees, editingApplication,
  previousApplications, toDelete }) => {
  let { employee } = application;
  let emp = {};
  let name = 'N/A';
  if (employees.length > 0 && employee !== undefined) {
    emp = employees.find((e) => e.eid === employee);
    if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
  }

  return (
    <div>
      { toDelete ? <h2 className="red-text chem-app-flex">Are you sure you want to delete the following log?</h2> : '' }
      { editingApplication ? <span className="app-log-header blue-text">Editing Mowing Log</span>
        : <div>
            <span className="right"><i className="material-icons brown-text lighten-4 medium">view_comfy</i></span>
            <span className="app-log-header">Mowing Log</span>
          </div>
      }
      <br />
      <hr />
      {
        previousApplications.length > 0 ?
          <div className="row">
            <h5 className="blue-text app-log-prev-header">Previous Applications - { application.location }, Round { application.round }</h5>
            <MowTable mowJobs={previousApplications} readOnly={true} />
          </div>
        : ''
      }
      <div className="row">
        <h5 className="blue-text app-log-prev-header">Application</h5>
        <h5>
          <span className="app-log-prev-header">
          { application.isComplete === 0 || application.isComplete === '0' ?
            <span className="label label-incomplete">Incomplete</span>
            : <span className="label label-complete">Complete</span>
          }
          </span>
        </h5>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Date</strong>
          <p>{ moment(application.date).format("dddd, MMMM Do YYYY") }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Employee</strong>
          <p>{ employees.length > 0 && employee !== undefined ? <span>{ name }</span> : 'N/A' }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Location</strong>
          <p>{ application.location === '71' ? '71 - Kau' : '72 - Keaau' }</p>
        </div>
        <div className="col s6 m3 l3 xl3 b-r">
          <strong>Round</strong>
          <p>{ application.round }</p>
        </div>
        <div className="col s12">
          <hr />
          <br />
          <div className="divider"></div>
          <div className="section chem-app-flex">
            <p><b>Comments: </b>{ application.comments }</p>
          </div>
          <div className="divider"></div>
        </div>
      </div>
      <div className="row">
        <div className="col s12">
          { application.mowJobs ?
            <MowTable mowJobs={application.mowJobs} readOnly={true} />
            : ''
          }
        </div>
      </div>


    </div>
  );
}


MowingApplicationDisplay.propTypes = propTypes;
export default MowingApplicationDisplay;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/mowing/mowing_app_display.js